<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">賃居調查統計表</span>
        <div role="tablist">
            <b-button class="mb-1" block v-b-toggle.accordion-1>賃居調查</b-button>
            <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <form-input v-model="vm.SYear" id="SYear" label="學年度" type="number" required></form-input>
                    </div>
                    <div class="col-md-6 col-sm-12">
                        <form-select v-model="vm.Semester" id="Semester" label="學期" required>
                            <div is="option" value="u">上</div>
                            <div is="option" value="d">下</div>
                        </form-select>
                    </div>
                    <!--<div class="col-12">
                        <form-input v-model="vm.ClassID" id="ClassID" label="班級" type="text" classlist required></form-input>
                    </div>-->
                    <div class="col-12">
                        <form-input v-model="vm.StudentNo" id="StudentNo" label="學號" type="text" student required></form-input>
                    </div>
                    <div class="col-12">
                        <form-select v-model="vm.RentState" id="RentState" label="賃居情形" required>
                            <slot name="rentstate"></slot>
                        </form-select>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <form-input v-model="vm.LandlordName" id="LandlordName" label="房東姓名" type="text" required></form-input>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <form-input v-model="vm.LandlordTel" id="LandlordTel" label="房東電話" type="tel" required></form-input>
                    </div>
                    <div class="col-md-4 col-sm-12">
                        <form-input v-model="vm.LandlordAddress" id="LandlordAddress" label="租屋地址" type="text" required></form-input>
                    </div>
                    <div class="col-12">
                        <form-select v-model="vm.Cooperate" id="Cooperate" label="配合市警察局租屋安全檢測" required>
                            <div is="option" value="y">同意</div>
                            <div is="option" value="n">不同意</div>
                        </form-select>
                    </div>
                    <div class="col-12">
                        <form-textarea v-model="vm.Remark" id="Remark" label="備考" type="text"></form-textarea>
                    </div>
                </div>
            </b-collapse>
            <b-button class="mb-1" block v-b-toggle.accordion-2 @click="tabpane2">訪視紀錄</b-button>
            <b-collapse id="accordion-2" visible accordion="my-accordion" role="tabpanel">
                <div class="row">
                    <div class="col-12">
                        <file-upload :url="'/api/rent/File?id='+modalkey" @ok="ok"></file-upload>
                    </div>
                    <div class="col-12" v-for="f in vm.Files" :key="f">
                        <a :href="Path+f" target="_blank">{{f}}</a>
                    </div>
                </div>
            </b-collapse>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'rentDetail',
        api: '/api/rent/',
        data: function () {
            return {
                vm: {
                    Files: []
                }
            };
        },
        computed: {
            isInsert: function () { return this.modalkey; },
            Path: function () { return this.$apiurl + this.vm.Dir },
        },
        methods: {
            tabpane2: function () {
                if (!this.isInsert) {
                    this.$bvToast.toast('請先儲存後再進行附件上傳', { title: '發生錯誤', variant: 'warning', solid: true });
                }
            },
            ok: function (e) {
                if (this.vm.Files == null) {
                    this.vm.Files = [];
                }
                this.vm.Files.push(e.res.data);
            }
        },
    });
</script>

<style>
</style>